<template>
  <card no-body
        shadow-size="sm"
        class="border-main-color" style="border-width: 0 0 0 5px">

    <div class="">
      <div class="row align-items-center">
        <div class="pl-5 mr-auto">
          <div class="mt-1"></div>
          <p class="m-0 text-custom-text font-weight-500 ">{{ title }}</p>
          <p class="m-0 font-size-11 font-weight-500 text-custom-gray-2">{{ create_date }}</p>
          <div class="mt-1"></div>
        </div>
        <div class="pr-5">
          <div v-if="fileCount === 0" class="text-custom-gray-2 font-size-11">
            檔案準備中
          </div>
          <button v-else type="button" class="btn btn-md btn-main-color"
                  :disabled="downloading" @click="clickDownload">
            {{ downloading ? '下載中...' : '下載' }}
          </button>
        </div>
      </div>
    </div>
  </card>
</template>

<script>
export default {
  name: "DownloadItem",
  props: {
    title: {
      type: String,
      default: ""
    },
    create_date: {
      type: String,
      default: ""
    },
    // 這筆紀錄目前掛了幾個檔案；0 代表還沒上傳，不能下載
    fileCount: {
      type: Number,
      default: 0,
    },
    // 實際下載邏輯（單檔直接下載／多檔打包成 zip）交給外層處理，
    // 這裡只負責觸發並顯示 loading 狀態
    onDownload: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      downloading: false,
    };
  },
  methods: {
    async clickDownload() {
      if (this.fileCount === 0 || this.downloading) return;
      this.downloading = true;
      try {
        await this.onDownload();
      } finally {
        this.downloading = false;
      }
    },
  },
}
</script>

<style scoped>

</style>
